import React from 'react'
import { calculatePercentage } from '../../utils/common'
import './style.scss'

const ProgressIndicator = ({ value, total }) => {
  const getPercentage = calculatePercentage(total, value)

  const getColor = () => {
    if (getPercentage > 80) {
      return 'success'
    } else if (getPercentage > 40) {
      return 'accent4'
    } else {
      return 'danger'
    }
  }

  return (
    <div className='viso-progress-indicator'>
      {value && <div className='viso-progress-indicator__value'>{value}</div>}
      <div className='viso-progress-indicator-bar'>
        <div className='viso-progress-indicator-bar__background' />
        <div
          className={`viso-progress-indicator-bar__fill viso-bg-${getColor()}`}
          style={{ width: `${calculatePercentage(total, value)}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressIndicator